(function () {
    let duration = 0

    const poll = setInterval(() => {
        duration += 100

        if (duration > 3000) {
            clearInterval(poll)
        }

        if (typeof _wssq !== 'undefined') {
            clearInterval(poll)

            _wssq.push(['suggest._bindEvent', 'open', () => {
                document.documentElement.classList.add('sooqr-open')
            }])

            _wssq.push(['suggest._bindEvent', 'close', () => {
                document.documentElement.classList.remove('sooqr-open')
            }])
        }
    }, 100)
})()
